export default function MountainDivider({ className = "" }) {
    return (
        <div className={`section-divider-mountain ${className}`} aria-hidden="true">
            <svg
                viewBox="0 0 1440 64"
                preserveAspectRatio="none"
                className="w-full h-full"
            >
                <path
                    d="M0 64 L120 28 L220 50 L320 12 L460 44 L560 18 L700 52 L820 22 L960 50 L1080 16 L1220 46 L1340 20 L1440 48 L1440 64 Z"
                    fill="currentColor"
                    opacity="0.18"
                />
                <path
                    d="M0 64 L120 36 L260 56 L400 28 L540 54 L680 30 L820 56 L960 32 L1100 56 L1240 30 L1360 50 L1440 36 L1440 64 Z"
                    fill="currentColor"
                    opacity="0.10"
                />
            </svg>
        </div>
    );
}
